import { networkController } from "@/libs/network/services/NetworkManager";
import { cn } from "@/utils/cn";
import { useEffect, useState } from "react";

export function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(networkController.isOnline());

  useEffect(() => {
    const unsubscribe = networkController.subscribe((onlineStatus) => {
      setIsOnline(onlineStatus);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <p
      className={cn("fixed right-0 top-0 bg-slate-500 p-2  z-50", {
        "text-red-500": !isOnline,
        "text-green-500": isOnline,
      })}
    >
      {isOnline ? "ONLINE" : "OFFLINE"}
    </p>
  );
}
